import { render, staticRenderFns } from "./CampaignHistoryTable.vue?vue&type=template&id=35996c77&scoped=true&"
import script from "./CampaignHistoryTable.vue?vue&type=script&lang=js&"
export * from "./CampaignHistoryTable.vue?vue&type=script&lang=js&"
import style0 from "./CampaignHistoryTable.vue?vue&type=style&index=0&id=35996c77&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35996c77",
  null
  
)

export default component.exports